import { Component, ViewChild } from '@angular/core';
import { AmministrazioneTrasparente } from '../../../shared/interface';
import { ApiService } from '../../../services/api.service';
import { Table } from 'primeng/table';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-amministrazione-trasparente-backoffice',
  templateUrl: './amministrazione-trasparente-backoffice.component.html',
  styleUrl: './amministrazione-trasparente-backoffice.component.css'
})
export class AmministrazioneTrasparenteBackofficeComponent {

  constructor(private apiService: ApiService, private confirmationService: ConfirmationService) {}

  @ViewChild("deleteFile") deleteFile!: ConfirmPopup;

  files: AmministrazioneTrasparente[] = []
  loading: boolean = false;

  ngOnInit(): void {
    
    this.loading = true;

    this.apiService.setFilesAmministrazioneTrasparente();
    this.apiService.filesAmministrazioneTrasparenteChanged.subscribe({
      next: (data) => {
        this.files = [...data];
        this.loading = false;
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),      
    })

  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDeleteFile(event: Event, file: AmministrazioneTrasparente) {        
    this.confirmationService.confirm({      
      target: event.target as EventTarget,
      message: `Sei sicuro di voler elimianre il file dell'amministrazione trasparente?`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteFileAmministrazioneTrasparente(file.id).subscribe({          
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {  
            this.confirmationService.close()
            this.apiService.setFilesAmministrazioneTrasparente()
            this.apiService.message("success", "Eliminazione", "Il file è stato eliminato con successo")
          }
        })
      }
    });
  }

  onDeleteFile() {
    this.deleteFile.accept();
  }

  onAnnullaDeleteFile() {
    this.deleteFile.reject();
  }

}
